module.exports = __webpack_public_path__ + "img/mobile-devices-yellow-hue.3c7f4ebb.jpg";